import actionType from 'redux/actions/actionConstant';

const initialState = {
    currentCredit: undefined,
    paymentMethod: undefined,
    intent: undefined,
    paymentMethods: undefined,
    showModal: false,
};

export default function billing(state = initialState, action) {
    switch (action.type) {
        case actionType.GET_CURRENT_CREDIT_SUCCESS:
            return {
                ...state,
                currentCredit: action.payload,
            };

        case actionType.SETUP_INTENT_SUCCESS:
            return {
                ...state,
                intent: action.payload.intent,
            };

        case actionType.PAYMENT_METHOD_SUCCESS:
            return {
                ...state,
                paymentMethods: action.payload.paymentMethods,
                intent: undefined,
            };

        case actionType.SHOW_MODAL:
            return {
                ...state,
                showModal: action.payload,
            };

        case actionType.LOGIN_SUCCESS:
            return {
                ...state,
                showModal: true,
            };

        case actionType.RESET_ALL_REDUCERS:
            return {
                ...state,
                currentCredit: undefined,
                paymentMethod: undefined,
                paymentMethods: undefined,
                showModal: false,
            };

        default:
            return state;
    }
}
